/**
 * FormFlu Header Component
 * 
 * Main navigation header with logo and navigation links.
 * Uses FormFlu brand colors and design system.
 */

import './Header.css';

interface HeaderProps {
  onLogin?: () => void;
  onSignup?: () => void;
}

export function Header({ onLogin, onSignup }: HeaderProps) {
  return (
    <header className="header">
      <div className="header-container container">
        {/* Logo */}
        <a href="/" className="header-logo">
          <img 
            src="/images/finalformflumainlogo.png" 
            alt="FormFlu" 
            className="header-logo-img"
          />
        </a>

        {/* Navigation */}
        <nav className="header-nav hide-mobile">
          <a href="#features" className="header-nav-link">Features</a>
          <a href="#pricing" className="header-nav-link">Pricing</a>
          <a href="#docs" className="header-nav-link">Documentation</a>
          <a href="#security" className="header-nav-link">HIPAA Security</a>
        </nav>

        {/* Auth Buttons */}
        <div className="header-actions">
          <button 
            onClick={onLogin}
            className="btn btn-ghost btn-sm"
          >
            Log In
          </button>
          <button 
            onClick={onSignup}
            className="btn btn-primary btn-sm"
          >
            Start Free Trial
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button className="header-menu-btn hide-desktop" aria-label="Open menu">
          <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <path d="M3 12h18M3 6h18M3 18h18" />
          </svg>
        </button>
      </div>
    </header>
  );
}
